import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../ui/button/button.component';
import { CookiesService } from '../../../platform/cookies/cookies.service';
import * as ModalActions from '../../../ngrx/modal/actions/modal.action';
import { Store } from '@ngrx/store';
import { CookiesManagingComponent } from '../cookies-managing/cookies-managing.component';
import { ModalComponent } from '../../../ui/modal/modal.component';
import { DATA_INJECTION_TOKEN } from '../../../ngrx/modal/services/modal.service';
import { LanguageChoiserComponent } from '../language-choiser/language-choiser.component';



export interface CookiesConsentModalData {
  modalName: string;
}

@Component({
    selector: 'app-consent',
    imports: [
        TranslateModule,
        ButtonComponent,
        ModalComponent,
        LanguageChoiserComponent
    ],
    templateUrl: './cookies-consent.component.html',
    styleUrl: './cookies-consent.component.scss'
})
export class CookiesConsentComponent {
  cookiesService = inject(CookiesService);
  store = inject(Store);
  data = inject<CookiesConsentModalData>(DATA_INJECTION_TOKEN);

  manageCookies(): void {
    const modalName = 'manage-cookies-modal';

    this.store.dispatch(
      ModalActions.open({
        cmpType: CookiesManagingComponent,
        fixed: true,
        props: {
          modalName
        }
      }));
  }

  acceptCookies(): void {
    this.cookiesService.setConsent({
      analytics_storage: 'granted',
      ad_personalization: 'granted',
      ad_user_data: 'granted',
      ad_storage: 'granted'
    });

    this.store.dispatch(ModalActions.close({
      modalName: this.data.modalName
    }));
  }
}
